import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "monetary-chart__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EChartsLine = _resolveComponent("EChartsLine")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_EChartsLine, {
      series: $data.series,
      isLoading: $data.isLoading,
      xAxisType: "time",
      stepMode: "middle",
      showEmphasisValues: "",
      titleConfig: $options.getChartTitleConfig,
      timeValueFormat: $options.getTimeValueFormat,
      valueFractionDigits: 2
    }, null, 8, ["series", "isLoading", "titleConfig", "timeValueFormat"])
  ]))
}